// src/tileset-manager/const.ts
import { UpdateTileStrategy } from "./types";
import {
  updateTileStateOverlap,
  updateTileStateRealtime,
  updateTileStateReplace
} from "./utils/strategies";
var TILE_SIZE = 256;
var DEFAULT_EXTENT = [-Infinity, -Infinity, Infinity, Infinity];
var BOUNDS_BUFFER_SCALE = 0.2;
var DEFAULT_CACHE_SCALE = 5;
var UPDATE_TILE_STRATEGIES = {
  [UpdateTileStrategy.Realtime]: updateTileStateRealtime,
  [UpdateTileStrategy.Overlap]: updateTileStateOverlap,
  [UpdateTileStrategy.Replace]: updateTileStateReplace
};
var NOOP = () => {
};
export {
  BOUNDS_BUFFER_SCALE,
  DEFAULT_CACHE_SCALE,
  DEFAULT_EXTENT,
  NOOP,
  TILE_SIZE,
  UPDATE_TILE_STRATEGIES
};
